/**
 * Коды ошибок модуля обучения: сообщение Error — код из этого перечисления или код ответа
 * сервера (not_found, already_answered, question_not_in_pack, hub_unavailable, validation_failed)
 */
export enum EnumEducationError {
  /** На устройстве нет ключа пользователя: вопросы не показываются и не создаются */
  NO_USER_KEY = 'no_user_key',
  /** Чужой ключ или испорченная строка: вопрос показывается как «Не удалось расшифровать» */
  CANNOT_DECRYPT = 'cannot_decrypt',
  /** Открытые данные вопроса больше 32 КБ */
  DATA_TOO_LARGE = 'data_too_large',
  /** Нет связи с сервером: окно закрыто плашкой */
  NO_CONNECTION = 'no_connection',
  /** Вопроса нет в списке модуля */
  QUESTION_NOT_FOUND = 'question_not_found',
  /** Нет текущего вопроса пачки, на который можно ответить */
  NO_CURRENT_QUESTION = 'no_current_question',
}
